import { designTokens } from '../lib/design-tokens'
import { typographyStyle } from '../lib/catalog'

export type SegmentedTabItem<T extends string> = {
  id: T
  label: string
}

type SegmentedTabsProps<T extends string> = {
  activeId: T
  ariaLabel: string
  items: SegmentedTabItem<T>[]
  onChange: (id: T) => void
}

export function SegmentedTabs<T extends string>({
  activeId,
  ariaLabel,
  items,
  onChange,
}: SegmentedTabsProps<T>) {
  return (
    <div role="tablist" aria-label={ariaLabel} className="flex flex-wrap items-center gap-2">
      {items.map((item) => {
        const isActive = item.id === activeId

        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className="inline-flex min-h-11 items-center justify-center rounded-full border px-4 py-2 transition-colors"
            style={{
              borderColor: isActive
                ? designTokens.colors.neutral.grey
                : designTokens.colors.border.adminPattern,
              backgroundColor: isActive
                ? designTokens.colors.neutral.grey
                : designTokens.colors.background.surface,
              color: isActive ? designTokens.colors.text.inverse : designTokens.colors.text.primary,
              fontFamily: designTokens.typography.fontFamilies.primary,
              ...typographyStyle(designTokens.typography.body.baseSemibold),
            }}
            onClick={() => {
              onChange(item.id)
            }}
          >
            {item.label}
          </button>
        )
      })}
    </div>
  )
}
